<template>
  <el-radio-group
    class="ui-segmented-control"
    :class="[`ui-segmented-control--${tone}`, `ui-segmented-control--${variant}`]"
    :value="value"
    :disabled="disabled"
    v-bind="$attrs"
    v-on="forwardedListeners"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
  >
    <el-radio-button
      v-for="option in options"
      :key="String(option.value)"
      :label="option.value"
      :disabled="option.disabled"
    >
      <slot name="option" :option="option">{{ $t(option.label) }}</slot>
    </el-radio-button>
  </el-radio-group>
</template>

<script>
export default {
  name: 'UiSegmentedControl',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number, Boolean],
      required: true
    },
    options: {
      type: Array,
      default: () => []
    },
    tone: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'warning', 'danger', 'accent'].includes(value)
    },
    variant: {
      type: String,
      default: 'control',
      validator: value => ['control', 'tabs'].includes(value)
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    forwardedListeners () {
      const listeners = { ...this.$listeners }
      delete listeners.input
      delete listeners.change
      return listeners
    }
  }
}
</script>

<!-- 外观统一在 src/styles/selection-controls.scss，兼容页面与挂到 body 的浮层。 -->
